import { Component } from 'react'
import { Box, Tab, EncodingDailyItems, AntennaStatus } from 'stylewhere/components'
import { EncodingExtensions } from 'stylewhere/extensions'
import { EncodingOperationConfig } from 'stylewhere/shared/RemoteOperation'
import { OperationEncodingTagType } from 'stylewhere/types'

interface Props {
  operation: EncodingOperationConfig
  options: any
  antennaOn?: boolean
  antennaTagType?: OperationEncodingTagType
  onTabClick?: any
  children?: any
  onResetDailyEncodedItems?: () => void
}

export class EncodingRightHeader extends Component<Props> {
  render() {
    const { operation, options, antennaOn, antennaTagType, onTabClick, children, onResetDailyEncodedItems } = this.props
    return (
      <Box row>
        {children ?? null}
        <EncodingDailyItems
          code={operation.code}
          style={{ minWidth: 130, marginRight: 10, borderRadius: 15 }}
          onPress={onResetDailyEncodedItems}
        />
        <Box mr={0} vcenter>
          <Tab
            onclick={onTabClick}
            options={options}
            onOptionSelected={(opt) => EncodingExtensions.getOptionEncodingPage(opt, operation)}
          />
        </Box>
        <AntennaStatus started={antennaOn || false} tagType={antennaTagType} />
      </Box>
    )
  }
}
